import { createApp } from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/stores'

import 'ant-design-vue/dist/antd.variable.min.css'
import '@/assets/style/main.less'
import '@szdh/dh-ui/dist/theme-chalk/css/index.css'
// 全局属性
import { installGlobal } from '/@/global'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
dayjs.locale('zh-cn')

import { setupRouterGuard } from '@/router/guard'
import Antd from 'ant-design-vue'

const app = createApp(App)
app.use(store).use(router)
// 注册全局属性
installGlobal(app)
setupRouterGuard(router)
router.isReady().finally(()=> {
  app.use(Antd).mount('#app')
})
